import { Component, OnInit } from '@angular/core';
import {NgbAccordionConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-accordion-toggle',
  templateUrl: './accordion-toggle.component.html',
  styleUrls: ['./accordion-toggle.component.css'],
   providers: [NgbAccordionConfig] // add the NgbAccordionConfig to the component providers	
})
export class AccordionToggleComponent implements OnInit {

  constructor(config: NgbAccordionConfig) {
    // customize default values of accordions used by this component tree
    config.closeOthers = true;
    config.type = 'info';
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/accordion-toggle/accordion-toggle.component.ts